import { AppContexts } from 'AppContexts';
import { ErrorBoundary } from 'components';
import 'devextreme/dist/css/dx.common.css';
import 'devextreme/dist/css/dx.light.css';
import { LandingPage } from 'pages';
import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { useScreenSizeClass } from 'utils/media-query';
import './App.scss';
import { AppRoutes } from './components/okta';
import './dx-styles.scss';
import './themes/generated/theme.additional.css';
import './themes/generated/theme.base.css';

export default function () {

  const screenSizeClass = useScreenSizeClass();
  
  return (
      <ErrorBoundary>
        <AppContexts>
          <>
            <Router basename="/">
              <div className={`app ${screenSizeClass}`}>
                <Routes>
                  <Route path="/" element={<LandingPage/>} />
                  <Route path="*" element={<AppRoutes />} />
                </Routes>
              </div>
            </Router>
          </>
        </AppContexts>
      </ErrorBoundary>
  )
}
